import { Alert, Button, Drawer, Form } from 'antd';
import type { DecisionTarget, DecisionValues } from '../hooks/use-expense-decision';
import { DECISION_LABELS } from '../policies/expense-decision';
import { ExpenseDecisionFields } from './ExpenseDecisionFields';
import { ExpenseSummary } from './ExpenseSummary';

interface ExpenseDecisionDrawerProps {
  target: DecisionTarget | null;
  error: string | null;
  submitting: boolean;
  onDecide: (values: DecisionValues) => Promise<void>;
  onClose: () => void;
}

/** A short form: the expense as the approver sees it, then what the decision needs. */
export function ExpenseDecisionDrawer({ target, error, submitting, onDecide, onClose }: ExpenseDecisionDrawerProps) {
  const [form] = Form.useForm<DecisionValues>();
  const label = target ? DECISION_LABELS[target.mode] : '';

  return (
    <Drawer open={target !== null} onClose={onClose} title={label} placement="right" size={420} destroyOnHidden>
      {error && <Alert className="mb-5" type="error" title={error} showIcon />}
      {target && <ExpenseSummary expense={target.expense} />}
      <Form<DecisionValues> form={form} layout="vertical" requiredMark={false} onFinish={onDecide} disabled={submitting}>
        {target && <ExpenseDecisionFields mode={target.mode} />}
        <Form.Item className="mb-0 pt-2">
          <Button type="primary" danger={target?.mode === 'reject'} htmlType="submit" loading={submitting}>
            {label}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
